import { classes } from "@shared/api/services"
import { useQuery } from "@tanstack/react-query"

export const useEnabledPromocode = (data) => {
	return useQuery({
		queryKey: ['promocode', data],
		queryFn: () => classes.getEnabledPromocode(data),
		select: data => data.data,
		enabled: !!data?.teacher_id,
		placeholderData: [],
		retry: false
	})
}